import type { AuthUser } from "@/types";

export const accountEmail = (identity?: {
  email?: string;
  id?: string;
  userId?: string;
}): string | undefined => {
  const email = identity?.email?.trim();
  const id = (identity?.userId || identity?.id)?.trim();
  // Guest addresses are generated as `${userId}@<synthetic-domain>`. A broad
  // substring check misclassifies legitimate accounts whose email happens to
  // contain their id, including accounts whose id is the email itself.
  return email && id && !email.startsWith(`${id}@`) ? email : undefined;
};

export const hasAccountIdentity = (
  user?: Pick<AuthUser, "email" | "userId">
): boolean => Boolean(accountEmail(user));

export const shouldAttachNativeAccount = (input: {
  isNative: boolean;
  isAuthenticated: boolean;
  user?: Pick<AuthUser, "email" | "userId">;
}): boolean =>
  input.isNative &&
  input.isAuthenticated &&
  !hasAccountIdentity(input.user);

export const shouldProtectGuestPurchase = (input: {
  isAuthenticated: boolean;
  user?: Pick<AuthUser, "email" | "userId">;
}): boolean =>
  input.isAuthenticated && !hasAccountIdentity(input.user);

export const safeAuthRedirect = (value?: string | null): string | undefined => {
  if (!value?.startsWith("/") || value.startsWith("//")) return undefined;
  const url = new URL(value, "https://app.1transcribe.com");
  if (!["/download", "/download/", "/desktop-connect", "/desktop-connect/", "/agent-connect", "/agent-connect/"].includes(url.pathname)) {
    return undefined;
  }
  return `${url.pathname}${url.search}`;
};
